import axios from "axios";
import React, {createContext, useContext, useEffect, useState} from "react";
import {useRequest} from "../utils";
import {storage} from "../utils/storage";

const AppContext = createContext();

export function AppWrapper({children}) {
    const [isLogin, setIsLogin] = useState(null);
    const [token, setToken] = useState(null);
    const [user, set_user] = useState(null);

    const checkLogin = () => {
        storage
            .load("token")
            .then((res) => {
                if (!res) {
                    return Promise.reject();
                } else {
                    return axios
                        .get("/check_token", {
                            headers: {
                                "x-auth": res,
                            },
                        })
                        .then((data) => {
                            if (data.data.message === "Token is available.") {
                                setIsLogin(true);
                                set_user(data.data.user);
                                // console.log(res);
                            } else {
                                storage.remove("token");
                                setIsLogin(false);
                                return Promise.reject();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            storage.remove("token");
                            return Promise.reject();
                        });
                }
            })
            .catch(() => {
                setIsLogin(false);
            });
    };

    useEffect(() => {
        checkLogin();
        if (isLogin) {
        }
    }, [isLogin]);

    let sharedState = {
        isLogin,
        setIsLogin,
        checkLogin,
        setToken,
        user,
        set_user

    };

    return (
        <AppContext.Provider value={sharedState}>{children}</AppContext.Provider>
    );
}

export function useAppContext() {
    return useContext(AppContext);
}
